/* Botaverra - deroule la liste des politiques sous le lien du pied de page.
   Voir l'entete de botaverra-pied-politiques.css pour le pourquoi du comment.
   Les liens viennent de window.BV_POLITIQUES, ecrit par stylesheets.liquid a
   partir du menu Shopify `pied-de-page-legal`. */
(function () {
  var liste = window.BV_POLITIQUES;
  if (!liste || !liste.length) return;

  var lien = document.querySelector('.bvf__links a[href*="/pages/nos-politiques"]');
  if (!lien) return;

  var li = lien.parentNode;
  while (li && li.tagName !== 'LI') li = li.parentNode;
  if (!li || li.dataset.bvpolmPret === 'oui') return;
  li.dataset.bvpolmPret = 'oui';

  li.className += ' bvpolm';
  li.setAttribute('data-ouvert', 'non');

  var sous = document.createElement('ul');
  sous.className = 'bvpolm__sub';
  sous.id = 'bvpolm-sous-menu';

  liste.forEach(function (item) {
    var l = document.createElement('li');
    var a = document.createElement('a');
    a.href = item.u;
    a.textContent = item.t;
    l.appendChild(a);
    sous.appendChild(l);
  });

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'bvpolm__t';
  btn.textContent = (lien.textContent || 'Nos politiques').trim();
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-controls', sous.id);

  /* Le lien d'origine ne disparait qu'ici, une fois le remplacant pret : si le
     script echoue avant cette ligne, le pied de page reste intact. */
  li.replaceChild(btn, lien);
  li.appendChild(sous);

  function basculer() {
    var ouvert = li.getAttribute('data-ouvert') === 'oui';
    li.setAttribute('data-ouvert', ouvert ? 'non' : 'oui');
    btn.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
    sous.style.maxHeight = ouvert ? '0px' : sous.scrollHeight + 'px';
  }

  btn.addEventListener('click', basculer);

  /* Ouverte, la liste garde une hauteur figee en pixels. Au redimensionnement
     un libelle peut passer sur deux lignes et se retrouver coupe : on remesure. */
  var minuteur;
  window.addEventListener('resize', function () {
    window.clearTimeout(minuteur);
    minuteur = window.setTimeout(function () {
      if (li.getAttribute('data-ouvert') === 'oui') {
        sous.style.maxHeight = sous.scrollHeight + 'px';
      }
    }, 150);
  });
})();
